// Community Photos Redux Actions
import { createRequestTypes } from "../../utils";

// ==================== ACTION TYPES ====================

// Community photo sharing
export const SHARE_PHOTO = createRequestTypes("SHARE_PHOTO");
export const UNSHARE_PHOTO = createRequestTypes("UNSHARE_PHOTO");

// Fetch gallery
export const FETCH_COMMUNITY_GALLERY = createRequestTypes("FETCH_COMMUNITY_GALLERY");

// Increment view
export const INCREMENT_PHOTO_VIEW = createRequestTypes("INCREMENT_PHOTO_VIEW");

// UI State
export const SET_GALLERY_FILTERS = 'SET_GALLERY_FILTERS';
export const SET_SELECTED_PHOTO = 'SET_SELECTED_PHOTO';
export const SET_LIGHTBOX_OPEN = 'SET_LIGHTBOX_OPEN';

// ==================== SHARE/UNSHARE ACTIONS ====================

export const sharePhotoRequest = (archiveId, showUploader = true) =>
    ({ type: SHARE_PHOTO.REQUEST, payload: { archiveId, showUploader } });

export const sharePhotoSuccess = (message) =>
    ({ type: SHARE_PHOTO.SUCCESS, payload: message });

export const sharePhotoFailure = (error) =>
    ({ type: SHARE_PHOTO.FAILURE, payload: error });

export const unsharePhotoRequest = (archiveId) =>
    ({ type: UNSHARE_PHOTO.REQUEST, payload: { archiveId } });

export const unsharePhotoSuccess = (archiveId) =>
    ({ type: UNSHARE_PHOTO.SUCCESS, payload: { archiveId } });

export const unsharePhotoFailure = (error) =>
    ({ type: UNSHARE_PHOTO.FAILURE, payload: error });

// ==================== GALLERY ACTIONS ====================

export const fetchCommunityGalleryRequest = (filters = {}) =>
    ({ type: FETCH_COMMUNITY_GALLERY.REQUEST, payload: filters });

export const fetchCommunityGallerySuccess = (data) =>
    ({ type: FETCH_COMMUNITY_GALLERY.SUCCESS, payload: data });

export const fetchCommunityGalleryFailure = (error) =>
    ({ type: FETCH_COMMUNITY_GALLERY.FAILURE, payload: error });

// ==================== VIEW INCREMENT ====================

export const incrementPhotoViewRequest = (archiveId) =>
    ({ type: INCREMENT_PHOTO_VIEW.REQUEST, payload: { archiveId } });

export const incrementPhotoViewSuccess = (archiveId, views) =>
    ({ type: INCREMENT_PHOTO_VIEW.SUCCESS, payload: { archiveId, views } });

export const incrementPhotoViewFailure = (error) =>
    ({ type: INCREMENT_PHOTO_VIEW.FAILURE, payload: error });

// ==================== UI STATE ACTIONS ====================

export const setGalleryFilters = (filters) =>
    ({ type: SET_GALLERY_FILTERS, payload: filters });

export const setSelectedPhoto = (photo) =>
    ({ type: SET_SELECTED_PHOTO, payload: photo });

export const setLightboxOpen = (isOpen) =>
    ({ type: SET_LIGHTBOX_OPEN, payload: isOpen });
